import { InjectionToken } from '@angular/core';
import { MessagingAdapterBase } from '../adapter/messaging-adapter.base';

export const MESSAGING_ADAPTER = new InjectionToken<MessagingAdapterBase>('MessagingAdapter');
